import { TranslationAction } from './types';

/*
 * This diff is merged into the translations and the translation-interface for local development.
 *
 * If you want them to become "productive":
 * - You can update them manually in the POEditor-Interface or via API request (`pnpm pushTranslations`)
 * - You set it back to an empty array if finished successfully
 *
 */
export const diff: TranslationAction[] = [
  {
    newTermWithContext: 'DeactivatedChambers',
    translation: 'Deactivated chambers',
  },
  {
    newTermWithContext: 'DeactivatedChambersExcludedMsg',
    translation:
      'The following chambers were deactivated with the active calibration and are excluded from measurements.',
  },
  {
    newTermWithContext: 'ChamberWithNumber',
    translation: 'Chamber {{number}}',
  },
  {
    newTermWithContext: 'DeactivatedByPtw',
    translation: 'Deactivated by PTW (DC)',
  },
  {
    newTermWithContext: 'DeactivatedByUser',
    translation: 'Deactivated by user (UC)',
  },
  {
    newTermWithContext: 'NotOnDetectorLayout',
    translation: 'Not on detector layout',
  },
  {
    newTermWithContext: 'ChambersDeactivatedCount',
    translation: '{{deactivated}} of {{total}} chambers deactivated',
  },
  {
    newTermWithContext: 'ShowFieldSizeLabels',
    translation: 'Show field size labels',
  },
  {
    newTermWithContext: 'ShowDeactivatedChambers',
    translation: 'Show deactivated chambers',
  },
  {
    newTermWithContext: 'DetectorChamberMap',
    translation: 'Detector chamber map',
  },
  {
    newTermWithContext: 'Source',
    translation: 'Source',
  },
  {
    newTermWithContext: 'CalibrationMissingTitle',
    translation: 'Calibration missing',
  },
  {
    newTermWithContext: 'UploadAndActivateLatestCalibrationFileMsg',
    translation: 'Please upload and activate the latest calibration file to perform measurements.',
  },
  {
    newTermWithContext: 'UploadCalibrationFile',
    translation: 'Upload calibration file',
  },
  {
    newTermWithContext: 'UploadCalibrationFileAssociatedWithLatestCalibrationMsg',
    translation: 'Upload the calibration file associated with the latest calibration.',
  },
  {
    newTermWithContext: 'UploadAndActivateCalibrationFile',
    translation: 'Upload and activate calibration file',
  },
  {
    newTermWithContext: 'UploadCalibrationCertificateFromLocalSystemMsg',
    translation: 'Upload the calibration certificate from your local system.',
  },
  {
    newTermWithContext: 'CalibrationFile',
    translation: 'Calibration file',
  },
  {
    newTermWithContext: 'VerifyCorrectCalibrationFileTitle',
    translation: 'Verify correct calibration file',
  },
  {
    newTermWithContext: 'VerifyCorrectCalibrationFileMsg',
    translation:
      'Please ensure that the correct calibration file is selected and uploaded from your local system. PTW Freiburg assumes no responsibility for the correctness of the uploaded file.',
  },
  {
    newTermWithContext: 'OnlyCalFileTypeAllowedMsg',
    translation: 'Only files of type .cal are allowed.',
  },
  {
    newTermWithContext: 'UploadCalibrationFileSuccessMsg',
    translation: 'Calibration file uploaded and activated.',
  },
  {
    newTermWithContext: 'CalibrationCertificateMissing',
    translation: 'Calibration missing',
  },
  {
    newTermWithContext: 'CalibrationCertificateMissingFor',
    translation: 'Calibration missing for {{name}} | {{iuid}} (SN {{serialNumber}})',
  },
  {
    newTermWithContext: 'CalibrationLaboratory',
    translation: 'Calibration laboratory',
  },
  {
    newTermWithContext: 'ActivatedBy',
    translation: 'Activated by',
  },
  {
    newTermWithContext: 'CalibrationDataSourceEnum.LocalUpload',
    translation: 'Local upload',
  },
  {
    newTermWithContext: 'CalibrationDataSourceEnum.PtwCloud',
    translation: 'PTW Cloud',
  },
  {
    newTermWithContext: 'TaskTypeDescriptionEnum.BeamAnalysis',
    translation: 'Beam Analysis',
  },
  {
    newTermWithContext: 'StartZeroMeasurement',
    translation: 'Start zero measurement',
  },
  {
    newTermWithContext: 'ZeroMeasurementDialogTitle',
    translation: 'Zero measurement',
  },
  {
    newTermWithContext: 'ZeroMeasurement',
    translation: 'Zero measurement',
  },
  {
    newTermWithContext: 'ZeroMeasurementDuration',
    translation: 'Measurement duration',
  },
  {
    newTermWithContext: 'ZeroMeasurementValidityDuration',
    translation: 'Validity duration',
  },
  {
    newTermWithContext: 'Validation.InvalidPublicationDate',
    translation: 'Invalid publication date',
  },
  {
    newTermWithContext: 'SelectOneInterfaceAndOneArrayMsg',
    translation:
      'Select exactly <strong>one detector interface</strong> and <strong>one array detector</strong> per group.',
  },
  {
    newTermWithContext: 'Corrections',
    translation: 'Corrections',
  },
  {
    newTermWithContext: 'DefaultValues',
    translation: 'Default values',
  },
  {
    newTermWithContext: 'AdjustValuesInMeasurement',
    translation: 'Adjust values in measurement',
  },
  {
    newTermWithContext: 'AirTemperature',
    translation: 'Air temperature',
  },
  {
    newTermWithContext: 'AirPressure',
    translation: 'Air pressure',
  },
  {
    newTermWithContext: 'ReferenceTemperature',
    translation: 'Reference temperature',
  },
  {
    newTermWithContext: 'ReferencePressure',
    translation: 'Reference pressure',
  },
  {
    newTermWithContext: 'CorrectionFactorKUser',
    translation: 'Correction factor (k_user)',
  },
  {
    newTermWithContext: 'DeviceStatusIslandTitle',
    translation: 'Device status',
  },
  {
    newTermWithContext: 'DeviceStatusIslandActiveDevices',
    translation: '{{count}} active devices',
  },
  {
    newTermWithContext: 'DeviceStatusIslandConnectedTo',
    translation: 'Connected to {{names}}',
  },
  {
    newTermWithContext: 'DeviceStatusIslandConnected',
    translation: 'Connected',
  },
  {
    newTermWithContext: 'DeviceStatusIslandReference',
    translation: 'REF: {{value}}',
  },
  {
    newTermWithContext: 'DeviceStatusIslandSerial',
    translation: 'SN: {{value}}',
  },
  {
    newTermWithContext: 'DeviceStatusIslandViewDetails',
    translation: 'View details for {{value}}',
  },
  {
    newTermWithContext: 'MeasurementStatus.ZeroMeasuring',
    translation: 'Zero measurement running',
  },
  {
    newTermWithContext: 'Validation.MinutesOutOfRange',
    translation: 'Minutes must be between 0 and 59.',
  },
  {
    newTermWithContext: 'ZeroMeasurementValidFor',
    translation: 'Zero measurement valid for {{duration}}',
  },
  {
    newTermWithContext: 'EvaluationLimitsHint',
    translation:
      'Enter the limits to be applied during the job execution to evaluate the measurement results.',
  },
  {
    newTermWithContext: 'EnumerationEvaluationHint',
    translation: 'Assign an evaluation result to an enumeration item.',
  },
  {
    newTermWithContext: 'InstructionForTaskExecution',
    translation: 'Instruction for task execution',
  },
  {
    newTermWithContext: 'ZeroMeasurementBlockedInterfaceBusy',
    translation: 'Detector interface is busy measuring',
  },
  {
    newTermWithContext: 'ZeroMeasurementBlockedInterfaceOffline',
    translation: 'Detector interface is offline',
  },
  {
    newTermWithContext: 'ZeroMeasurementBlockedNoArray',
    translation: 'No array detector connected',
  },
  {
    newTermWithContext: 'CancelZeroMeasurement',
    translation: 'Cancel zero measurement',
  },
  {
    newTermWithContext: 'CancelZeroMeasurementConfirmation',
    translation: 'Cancel the running zero measurement?',
  },
  {
    newTermWithContext: 'ZeroMeasurementCompleted',
    translation: 'Zero measurement completed',
  },
  {
    newTermWithContext: 'Text',
    translation: { one: 'Text', other: 'Texts' },
  },
  {
    newTermWithContext: 'QuantitiesAndUnitsDescriptionMsg',
    translation: 'Manage quantities, enumerations, texts and units.',
  },
  {
    newTermWithContext: 'TextNotUsedInSetupsMsg',
    translation: 'This text is not used in setups.',
  },
  {
    newTermWithContext: 'ZeroMeasurementStatusShort.Initializing',
    translation: 'Preparing device',
  },
  {
    newTermWithContext: 'ZeroMeasurementStatusShort.ZeroMeasuring',
    translation: 'Measuring',
  },
  {
    newTermWithContext: 'ZeroMeasurementStatusShort.Finished',
    translation: 'Completed',
  },
  {
    newTermWithContext: 'Detector',
    translation: 'Detector',
  },
  {
    newTermWithContext: 'REF',
    translation: 'REF',
  },
  {
    newTermWithContext: 'DetectorConfirmationTitle',
    translation: 'Confirm the detector in use',
  },
  {
    newTermWithContext: 'DetectorConfirmationInstruction',
    translation:
      'Check the type label on the detector and compare it with the selected set. Measuring with a different detector leads to invalid results.',
  },
  {
    newTermWithContext: 'DetectorConfirmationPickInstruction',
    translation:
      'Several {{model}} arrays are registered. Select the serial number printed on the connected detector.',
  },
  {
    newTermWithContext: 'DetectorConfirmationStatement',
    translation: 'I confirm that {{model}}, SN {{serial}}, is set up at {{target}}.',
  },
  {
    newTermWithContext: 'DetectorConfirmationStatementNoTarget',
    translation: 'I confirm that {{model}}, SN {{serial}}, is the detector in use.',
  },
  {
    newTermWithContext: 'DetectorConfirmationConfirm',
    translation: 'Confirm set',
  },
  {
    newTermWithContext: 'DetectorConfirmationConfirmed',
    translation: '{{model}}, SN {{serial}}, confirmed as the detector in use.',
  },
  {
    newTermWithContext: 'DetectorConfirmationChange',
    translation: 'Change',
  },
  {
    newTermWithContext: 'DetectorConfirmationMismatch',
    translation:
      'SN {{serial}} belongs to the {{model}} “{{name}}”, not to the array of this set. Check the label on the detector and the selected set.',
  },
  {
    newTermWithContext: 'DetectorConfirmationReportedConnected',
    translation: '{{interface}} reports a connected {{type}}.',
  },
  {
    newTermWithContext: 'DetectorConfirmationReportedNoArray',
    translation: '{{interface}} reports no connected array.',
  },
  {
    newTermWithContext: 'DetectorConfirmationReportedOffline',
    translation: '{{interface}} is offline and reports nothing.',
  },
  {
    newTermWithContext: 'DetectorConfirmationLookupFailed',
    translation:
      'The registered arrays could not be loaded. Compare the serial number on the label with the set yourself.',
  },
  {
    newTermWithContext: 'ZeroMeasurementBlockedDetectorUnconfirmed',
    translation: 'Confirm the detector in use first',
  },
];
